import { createContext, PropsWithChildren, ReactNode, useContext, useState } from 'react';

export interface MobileHeaderConfig {
    /**
     * Page title to display in mobile header
     */
    title: ReactNode;

    /**
     * URL to navigate back to
     */
    backUrl: string;

    /**
     * Show user widget in mobile header
     * @default false
     */
    showUserWidget?: boolean;

    isLoading?: boolean;
}

interface NavigationContextValue {
    mobileHeaderOverride: MobileHeaderConfig | null;
    setMobileHeaderOverride: (config: MobileHeaderConfig | null) => void;
}

const NavigationContext = createContext<NavigationContextValue | undefined>(undefined);

export function NavigationProvider({ children }: PropsWithChildren) {
    const [ mobileHeaderOverride, setMobileHeaderOverride ] = useState<MobileHeaderConfig | null>(null);

    return (
        <NavigationContext.Provider value={{ mobileHeaderOverride, setMobileHeaderOverride }}>
            { children }
        </NavigationContext.Provider>
    );
}

export function useNavigationContext() {
    const context = useContext(NavigationContext);

    if (!context) {
        throw new Error('useNavigationContext must be used within NavigationProvider');
    }

    return context;
}
